// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

export const EXPECTED_QUICK_SPECS = [
	'odometer',
	'cityFuelEconomy',
	'highwayFuelEconomy',
	'exteriorColor',
	'interiorColor',
	'normalExteriorColor',
	'normalInteriorColor',
	'bodyStyle',
	'transmission',
	'driveLine',
	'engine',
	'engineSize',
	'combinedFuelEfficiency',
	'range',
	'batteryWarranty'
];

export const EV_QUICK_SPECS = [
	{
		key: 'range',
		titleLabel: 'EV_RANGE_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_RANGE_SPEC_DETAILS_VERBIAGE',
		value: null
	},
	{
		key: 'combinedFuelEfficiency',
		titleLabel: 'EV_COMBINEDFUELEFFICIENCY_SPEC_TITLE_VERBIAGE',
		detailLabel: 'EV_COMBINEDFUELEFFICIENCY_SPEC_DETAILS_VERBIAGE',
		value: null
	}
];

export const SEATING_SPEC_ID = 2050;
export const NORMALIZED_TRANSMISSION_SPEC_ID = 340;
export const NORMALIZED_DRIVELINE_SPEC_ID = 500;
export const EQUIPMENT_COMBINED_FUEL_ECONOMY_SPEC_ID = 551;
export const EQUIPMENT_RANGE_SPEC_ID = 115;
export const EQUIPMENT_BATTERY_WARRANTY_SPEC_ID = 5220;
export const EQUIPMENT_EV_TYPE_SPEC_ID = 113;

export const FLAG_ENABLE_EV_DETAIL_LINK = 'show-ev-detail-link';
export const FLAG_USE_QUICK_SPECS_FROM_IDC = 'use-quick-specs-from-idc';
